import { observable, reaction, action, computed } from 'mobx'
import { 
  getCurrentFetchHandler,
  getTargetAndSubordinateDistrict,
 } from '../utils/fetchData'
import GroupInfoStore from './GroupInfoStore'
import RegionalDivisionStore from './RegionalDivisionStore'
import GlobalControlStore from './GlobalControlStore'

/*
  userInfo 將user信息存儲
*/
class UserInfoStore {
  @observable userInfo = {}
  @observable username = null
  @observable name = null
  @observable id = null
  @observable groupId = null
  @observable role = null
  @observable phone = null
  @observable email = null
  @observable login = false
  @observable initFlag = false
  @observable logout = false
  @observable accountUseNewRules=true

 

  @computed
  get accountIsNotGraded () {
    if(this.role === 'PROVINCIAL' || this.role === 'PREFECTURAL' || this.role === 'COUNTY' || this.role === 'TOWNSHIP' || this.role === 'COMMUNITY') {
      return false
    }else {
      return true
    }
  }

  @computed
  get accountIsGraded () {
    return !this.accountIsNotGraded
  }

  @action
  updateAccountUseNewRules = async () => {
    await new Promise(
      (resolve) => getTargetAndSubordinateDistrict((res) => {
          if (res.content.count === 0) {
            this.accountUseNewRules = false
          } else if (res.content.count > 0) {
            this.accountUseNewRules = true
          }
          resolve()
      })
    )
  }
}
const store = new UserInfoStore()

const loginReaction = new reaction(
  () => store.login,
  (login, reaction) => {
    if (login) {
      getCurrentFetchHandler(
        (data) => {
          if (data.groupId) {
            GroupInfoStore.needUpdate = true
            store.groupId = data.groupId
          }
          store.id = data.id
          store.phone = data.phone || '未设置' //此值用来判断
          store.email = data.email || ''
          store.username = data.username
          store.name = data.name || ''
          store.role = data.role
          GlobalControlStore.TopTips = data.remindStickySwitch
          GlobalControlStore.MusicTips = data.remindSoundSwitch
        },
        () => {},
        () => {}
      )
    }
  }
)


export default store



// WEBPACK FOOTER //
// ./src/store/UserInfoStore.js